import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=0c70c27a"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js"
import style0 from "./ProfilePhoto.vue?vue&type=style&index=0&id=0c70c27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports